<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true"  dataKey="name"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'tableManagement.insurance.insuranceComponentTitle' | translate }}
    </div>
  </ng-template>
  <!-- #endregion TABLE TITE DEFINITION -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- POLICY NUMBER -->
      <th pSortableColumn="description">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.insurance.description' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="description"></p-sortIcon>
            <p-columnFilter field="description" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false" ></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- START DATE -->
      <th pSortableColumn="startDate">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.financing.start' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="startDate"></p-sortIcon>
          </div>

        </div>
      </th>

      <!-- END DATE -->
      <th pSortableColumn="endDate">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.financing.end' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="endDate"></p-sortIcon>

          </div>

        </div>
      </th>

      <!-- COST -->
      @if (canSeeCosts) {
        <th pSortableColumn="cost">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.insurance.cost' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="cost"></p-sortIcon>
              <p-columnFilter field="cost" type="numeric" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- FLEET COST -->
      @if (canSeeCosts) {
        <th pSortableColumn="fleetCost">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.insurance.fleetCost' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="fleetCost"></p-sortIcon>
              <p-columnFilter field="fleetCost" type="numeric" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- DELETE -->
      @if (isDeleteGranted) {
        <th class="button-column"></th>
      }

    </tr>
  </ng-template>
  <!-- #endregion TABLE COLUMN DEFINITION -->

  <!-- #region TABLE BODY -->
  <ng-template pTemplate="body" let-entity>

    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(entity)">

      <!-- OBSERVATIONS -->
      <td>
        {{ entity.description }}
      </td>

      <!-- START DATE -->
      <td>
        {{ entity.startDate | date: 'dd/MM/yyyy' }}
      </td>

      <!-- END DATE -->
      <td>
        {{ entity.endDate | date: 'dd/MM/yyyy' }}
      </td>

      <!-- COST -->
      @if (canSeeCosts) {
        <td>
          {{ entity.cost | number: '1.2-2'}} €
        </td>
      }

      <!-- FLEET COST -->
      @if (canSeeCosts) {
        <td>
          {{ entity.fleetCost | number: '1.2-2'}} €
        </td>
      }

      <!-- DELETE -->
      @if (isDeleteGranted) {
        <td>
          <button type="button" class="btn custom-table-remove-button" (click)="onDeleteInsuranceComponent(entity)">
            <svg-icon
              src="assets/icons/trash.svg"
              class="d-flex flex-wrap custom-table-remove-button-icon"
              [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
            ></svg-icon>
          </button>
        </td>
      }

    </tr>

  </ng-template>
  <!-- #endregion TABLE BODY -->

  <!-- #region TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="colspan" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE EMPTY MESSAGE -->

  <!-- #region TABLE FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td [attr.colspan]="colspan" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">



          <div class="d-flex flex-row " style="margin-left: auto;">

            @if (isCalculationGranted) {
              <div class="buttonTableExcel custom-image-button"
                pTooltip="{{'tableManagement.insurance.calculateQuarter' | translate }}"
                tooltipPosition="top" (click)="showQuarterlyCalculation()">
                <svg-icon src="assets/icons/upload-file.svg"
                [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
              </div>
            }

          </div>
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE FOOTER -->

</p-table>

<!-- CONFIRM SAVE EVENT DIALOG -->
<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.messageDocument' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="insurance-component-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>
<app-insurance-quarterly-calculation [insurance]="insurance" (refreshTable)="refresh()"></app-insurance-quarterly-calculation>
<app-insurance-comp-form></app-insurance-comp-form>